module.exports = __webpack_public_path__ + "static/media/img_annual_dist.0733e4ea.png";